import { render, staticRenderFns } from "./Recompensas.vue?vue&type=template&id=156fe620&scoped=true"
import script from "./Recompensas.vue?vue&type=script&lang=js"
export * from "./Recompensas.vue?vue&type=script&lang=js"
import style0 from "./Recompensas.vue?vue&type=style&index=0&id=156fe620&prod&lang=css"
import style1 from "./Recompensas.vue?vue&type=style&index=1&id=156fe620&prod&scoped=true&lang=css"
import style2 from "./Recompensas.vue?vue&type=style&index=2&id=156fe620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156fe620",
  null
  
)

export default component.exports